/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import MainLayout from '../Layouts/Mainlayout'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Grid from '@mui/material/Grid';
import { Autocomplete, Box, Divider, TextField } from '@mui/material';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { useSelector } from 'react-redux';
import type { appConfigs, RootState, TemplateSummaryProps, VersionItem } from '../types/types';
import { gettemplateById, updatetemplate, gettemplateVersionList, updateTemplateVersion } from 'src/services/templateService';
// @ts-ignore
import { html as beautifyHtml } from 'js-beautify';

import { NotificationManager } from 'react-notifications';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Typography, IconButton } from '@mui/material';
import {
    ERR_EMAIL, ERR_EMAIL_INVALID, TEMPLATE_NAME_ERROR, TEMPLATE_FROM_NAME_ERROR,
    TEMPLATE_SUBJECT_LINE_ERROR, TEMPLATE_PREHEADER_ERROR, ADD_TEMPLATE_SUCCESS_MESSAGE,
    TEMPLATE_NAME, TEMPLATE_FROM_NAME, TEMPLATE_FROM_EMAIL, TEMPLATE_PREHEADER,
    TEMPLATE__SUBJECT_LINE,
    UPDATE_TEMPLATE_SUCCESS_MESSAGE,
    UNKNOWN_ERR,
    TEMPLATE_NAME_INVALID,
    TEMPLATE_FROM_NAME_INVALID,
    TEMPLATE_PREHEADER_RESEND_MESSAGE,
    TEMPLATE_RESEND_SUBJECT_LINE_MESSAGE,
    TEMPLATE_EDITING_DISABLED_MESSAGE,
    UPDATE_TEMPLATE_VERSION_SUCCESS_MESSAGE,
    TEMPLATE_REPLY_TO_EMAIL} from 'src/constants/constant';

import SendTestEmail from '../SendTestEmail/SendTestEmailTemplate';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { AddCircleStrokeRounded, HelpCircleIcon, Delete03Icon, CircleArrowMoveUpLeftIcon,Clock01Icon } from '@hugeicons-pro/core-stroke-rounded';

//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import CustomEditor from './CustomEditor';
import he from "he";
import MUIModal from '../MUIModal/MUIModal';
import TemplateImageUpload from './TemplateImageUpload';
import { styled } from "@mui/material/styles";
import type { TooltipProps } from "@mui/material/Tooltip";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import moment from 'moment';
import { checkEventPermission, checkSpelling } from "../../common/utility/utility";
import TemplateSummary from './TemplateSummary';
import TemplateVersionHistory from './TemplateVersionHistory';
import Loader from '../Loader';
import * as EmailValidator from 'email-validator';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';


export interface NewTemplateInputs {
    id?: number;
    clientId?: number;
    templateName: string;
    templateContent?: string | null;
    subjectLine: string;
    fromName: string;
    fromEmail: string;
    replyToEmail?: string | null;
    preheader: string;
    resendSubjectLine?: string | null;
    resendPreheader?: string | null;
    updatedBy?: number;
    unsubscribeLink?: string;
    UnsubscribeUrl?: string;
    TemplateVersion?: string;
    TemplateVersionId?: string;
    TemplateIdentifier?: string;
    IsNewTemplateVersion: boolean;
    ResendPreheaders?: {
        EmailSendOrder: number;
        Subject: string;
        Preheader: string;
    }[];
}

interface UploadedFile {
    id: string;
    file?: File;
    preview: string;
    url: string;
    size: string;
}
const validationSchema = Yup.object().shape({
    templateName: Yup.string().required(TEMPLATE_NAME_ERROR).matches(/^\S.*\S$|^\S$/, TEMPLATE_NAME_INVALID),
    fromName: Yup.string().required(TEMPLATE_FROM_NAME_ERROR).matches(/^\S.*\S$|^\S$/, TEMPLATE_FROM_NAME_INVALID),
    fromEmail: Yup.string().required(ERR_EMAIL).matches(/^\S.*\S$|^\S$/, ERR_EMAIL_INVALID),
    subjectLine: Yup.string().required(TEMPLATE_SUBJECT_LINE_ERROR).matches(/^\S.*\S$|^\S$/, "Please enter a valid subject line"),
    preheader: Yup.string().required(TEMPLATE_PREHEADER_ERROR).matches(/^\S.*\S$|^\S$/, "Please enter a valid preheader"),
    replyToEmail: Yup.string()
        .nullable()
        .notRequired()
        .email(ERR_EMAIL_INVALID)
        .test(
          'is-valid-email',
          ERR_EMAIL_INVALID,
          (value) => (value === '' || EmailValidator.validate(value ?? '')),
        ),
});
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: { backgroundColor: theme.palette.common.black }
}));

const EditTemplateForm: React.FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [templateData, setTemplateData] = useState<any>()
    const [showFields, setShowFields] = useState(false);
    const [charCount, setCharacterCount] = useState(0);
    const param = useParams();
    const { id } = param;
    const navigate = useNavigate()
    const { user } = useSelector((state: RootState) => state.auth);
    const [fieldCharCount, setFieldCharCount] = useState({
        fromName: 0,
        subjectLine: 0,
        preheader: 0,
        resendSubjectLine: 0,
        resendPreheader: 0,
    });
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [showImageModal, setShowImageModal] = useState<boolean>(false);
    const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
    const [editorDecodedContent, setEditorDecodedContent] = useState<string>('');
    const [editorContent, setEditorContent] = useState<string>('');
    const [links, setLinks] = useState<string[]>([]);
    const [images, setImages] = useState<{ src: string; alt: string }[]>([]);
    const [templateSummary, setTemplateSummary] = useState<boolean>(false);
    const [templateSummaryData, setTemplateSummaryData] = useState<TemplateSummaryProps>();
    const [domainValue, setDomainValue] = useState<string>('');
    const [isNewVersion, setIsNewVersion] = useState(false);
    const [showVersionPanel, setShowVersionPanel] = useState(false);
    const [VersionPanelLoading, setVersionPanelLoading] = useState(false);
    const [templateVersionData, setTemplateVersionData] = useState<VersionItem[]>([]);
    const [subjectLineSpellingError, setSubjectLineSpellingError] = useState<string>('');
    const [preheaderSpellingError, setPreheaderSpellingError] = useState<string>('');


    const [resendFields, setResendFields] = useState([{ subjectLine: '', preheader: '' }]);

    const storedAppConfig = localStorage.getItem("appConfigs");
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : [];

    const ResendMaxValue: any = parsedAppConfig.find(
        (item) => item.configType === "CampaignSettings" && item.configName === "ResendMaxValue"
    )?.configValue;

    const hasPermission = !!checkEventPermission('TEMPLATE_UPDATE'); 
    const isActive = templateData?.status === 1 || templateData?.isTemplateInUse === 1;
    const isAdmin = !!checkEventPermission('TEMPLATE_EDIT_APPROVED');
    const isDisabled = !hasPermission ||  (!isAdmin && isActive)   
    const [showUpdateTemplateModal, setShowUpdateTemplateModal] = useState<boolean>(false);
    const [pendingTemplateData, setPendingTemplateData] = useState<NewTemplateInputs | null>(null);
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);
    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
        },
    }));

    const {
        control,
        handleSubmit,
        setValue,
        watch,
        setError,
        clearErrors,
        trigger,
        formState: { errors },
    } = useForm<NewTemplateInputs>({
        //@ts-ignore
        resolver: yupResolver(validationSchema),
    });
    const templateName = watch("templateName");
    const editorRef = useRef(null);
    useEffect(() => {
        getemplateData()
    }, [id])
    const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
    const getemplateData = async (): Promise<void> => {
        setIsDataLoading(true)
        try {
            const templateId: any = id;
            if (templateId === null) return;
            // setIsLoading(true)
            const res: any = await gettemplateById(templateId);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (res.status === 200 && res.data.data.length > 0) {
                console.log(res.data.data[0]);
                const template = res.data.data[0]; // Access the first brand in the array
                setTemplateData(template);
                const emailValue = template.fromEmail;
                if (emailValue) {
                    const atIndex = emailValue.indexOf('@');
                    const localPart = emailValue.substring(0, atIndex);
                    const domainPart = emailValue.substring(atIndex + 1);
                    setValue("fromEmail", localPart); // set only the name before @
                    setDomainValue(domainPart); // set domain part
                }
                console.log(template.templateContent);
                // Set form values
                setValue("templateName", template.templateName);
                setValue("fromName", template.fromName);
                setValue("replyToEmail", template.replyToEmail || ''); // Set replyToEmail if it exists, otherwise set to empty string
                setValue("subjectLine", template.subjectLine)
                setValue("preheader", template.preheader)
                // setValue("resendSubjectLine", template.resendSubjectLine)
                // setValue("resendPreheader", template.resendPreheader)
                setValue("unsubscribeLink", template.unsubscribeUrl);
                setEditorContent(template.templateContent);
                // Update character counts based on initial values
                setFieldCharCount({
                    fromName: template.fromName?.length || 0,
                    subjectLine: template.subjectLine?.length || 0,
                    preheader: template.preheader?.length || 0,
                    resendSubjectLine: template.resendSubjectLine?.length || 0,
                    resendPreheader: template.resendPreheader?.length || 0,
                });

                // Show resend fields if they have values
                if (template?.resendPreheaders && Array.isArray(template.resendPreheaders)) {
                    setResendFields(
                        template.resendPreheaders.map((r: any) => ({
                            subjectLine: r.subject || '',
                            preheader: r.preheader || ''
                        }))
                    );
                    setShowFields(template.resendPreheaders.length > 0);
                }


            }
        } catch (error) {
            console.error("Error fetching brand data:", error);
            NotificationManager.error("Error loading brand data");
        } finally {
            setIsDataLoading(false)
            setIsLoading(false)
        }
    }

    const handleAddResendField = (): void => {
        if (resendFields.length < ResendMaxValue) {
            setResendFields([...resendFields, { subjectLine: '', preheader: '' }]);
        }
    };
    const handleRemoveResendField = (idx: number): void => {
        setResendFields(resendFields.filter((_, i) => i !== idx));
    };
    const handleResendFieldChange = (idx: number, field: 'subjectLine' | 'preheader', value: string): void => {
        const updated = [...resendFields];
        updated[idx][field] = value;
        setResendFields(updated);
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFieldCharCount((prev) => ({
            ...prev,
            [name]: value.length, // Update the specific field based on the input's name
        }));
    };
    const updateEditorContent = (newHtml: string): void => {
        setEditorContent(newHtml);
        //@ts-ignore
        editorRef.current?.updateContent?.(newHtml);
    };

    const onSubmit = async (data: NewTemplateInputs): Promise<void> => {
        setIsLoading(true)
        const isAdminUser = !!checkEventPermission('TEMPLATE_EDIT_APPROVED') ;
        console.log(isAdminUser, templateData?.status === 1);
        if (isAdminUser &&  templateData?.status === 1) {
            // Show confirmation modal for admin users
            setPendingTemplateData(data);
            setShowUpdateTemplateModal(true);
            setIsLoading(false); // Reset loading since we're showing modal
            setIsModalSaveLoading(false);
            return; 
        }
            await processTemplateUpdate(data);
    }
        // } else {
    const processTemplateUpdate = async (data: NewTemplateInputs): Promise<void> => {
        setIsLoading(true);
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!data.resendPreheader) {
            data.resendPreheader = null;
        }
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!data.resendSubjectLine) {
            data.resendSubjectLine = null;
        }
        if (domainValue) {
            if (!data.fromEmail.includes(`@${domainValue}`)) {
                data.fromEmail = `${data.fromEmail}@${domainValue}`;
            }
        }

        if (!editorContent || editorContent.trim() === '') {
            setIsLoading(false)
            NotificationManager.error('Template content cannot be empty.', '', 5000);
            return; // Stop submission
        }
        const preheaderDiv = `<div id="preheader" style="display: none; max-height: 0px; overflow: hidden; font-size: 0px; color: #ffffff; line-height: 0;">{{preheader}} </div>`;

        const parser = new DOMParser();
        const doc = parser.parseFromString(editorContent, 'text/html');

        // Check if preheader already exists
        const existingPreheader = doc.querySelector('#preheader');

        if (!existingPreheader) {
            console.log("🆕 Adding preheader div...");

            // Convert JSX to an actual DOM element
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = preheaderDiv
            const preheaderElement = tempContainer.firstElementChild as HTMLElement;
            if (preheaderElement) {
                // Find the first <div> in the document
                const firstDiv = doc.querySelector('div');

                if (firstDiv) {
                    // ✅ Insert preheader before the first existing div
                    firstDiv.insertAdjacentElement('beforebegin', preheaderElement);
                } else {
                    // ✅ Find the first valid element
                    const validElements = Array.from(doc.body?.children || doc.children).filter(
                        (el) => !['HTML', 'HEAD', 'TITLE', 'STYLE'].includes(el.tagName)
                    );

                    if (validElements.length > 0) {
                        // ✅ Insert before the first valid element
                        validElements[0].insertAdjacentElement('beforebegin', preheaderElement);
                    } else {
                        // ✅ Insert at the beginning of the body if no valid element is found
                        doc.body.insertAdjacentElement('afterbegin', preheaderElement);
                    }
                }
            }
        } else {
            console.log("✅ Preheader div already exists. Skipping insertion.");
        }

        // Convert back to HTML string
        const updatedEditorContent = new XMLSerializer().serializeToString(doc);
        setEditorContent(updatedEditorContent);


        // Update the TinyMCE editor content if available
        //@ts-ignore
        if (editorRef.current?.updateContent) {
            //@ts-ignore
            editorRef.current.updateContent(updatedEditorContent);
        }

        const hasUnsubscribePlaceholder = updatedEditorContent.includes('{{unsubscribelink}}');

        if (!hasUnsubscribePlaceholder && !data.unsubscribeLink) {
            setIsLoading(false)
            setError('unsubscribeLink', {
                type: 'manual',
                message: 'Please select the Unsubscribe link.',
            });
            return; // Stop submission
        } else {
            clearErrors('unsubscribeLink');
        }

        data.id = id ? parseInt(id, 10) : undefined;
        data.updatedBy = user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;
        data.fromEmail = data.fromEmail;
        const beautifiedHtml = beautifyHtml(updatedEditorContent, {
            indent_size: 2,
            wrap_line_length: 120,
        });

        // Update editorContent with beautified version
        setEditorContent(beautifiedHtml);

        // Update the TinyMCE editor content if available
        //@ts-ignore
        if (editorRef.current?.updateContent) {
            //@ts-ignore
            editorRef.current.updateContent(beautifiedHtml);
        }
        data.templateContent = beautifiedHtml;
        data.UnsubscribeUrl = data.unsubscribeLink ?? "";
        data.IsNewTemplateVersion = isNewVersion;
        data.TemplateVersion = templateData.templateVersion ?? 0;
        data.TemplateVersionId = templateData.templateVersionId ?? 0;
        data.TemplateIdentifier = templateData.templateIdentifier ?? "";

        const ResendPreheaders = resendFields.map((resend, idx) => (
            resend.subjectLine !== '' && resend.preheader !== '' ? {
                EmailSendOrder: idx + 1,
                Subject: resend.subjectLine,
                Preheader: resend.preheader,
            }
                : null)).filter((item): item is { EmailSendOrder: number; Subject: string; Preheader: string } => item !== null);
        data.ResendPreheaders = ResendPreheaders;

        try {
            console.log(data);
            const formData = new FormData();

            uploadedFiles.forEach((file) => {
                if (file.file) {  // ✅ Ensure `file.file` is not undefined before appending
                    formData.append("templateImages", file.file, file.file.name);
                }
            });
            formData.append("requestData", JSON.stringify(data));
            console.log(formData);
            const res = await updatetemplate(formData);
            if (res.status === 200) {
                if (res.data.result === 1) {
                    // NotificationManager.success(UPDATE_TEMPLATE_SUCCESS_MESSAGE);
                    setTemplateSummary(true);
                    setTemplateSummaryData(res.data.data);
                } else if (res.data.messages === 'Template was not added.') {
                    NotificationManager.error('Template name already exists');
                }
                else if (res.data.messages === 'Invalid From Email address format') {
                    NotificationManager.error('Please enter a valid email address');
                }
                else {
                    NotificationManager.error(UNKNOWN_ERR);
                }
            }
        } catch (error) {
            console.error('Error occurred:', error);
            NotificationManager.error(UNKNOWN_ERR);
        } finally {
            setIsLoading(false);
        }
            
    }

    const handleCancel = (): void => {
        navigate('/template')
    }

    const handleDeleteResendFields = (): void => {
        // Clear only the resend fields
        setValue('resendSubjectLine', '');
        setValue('resendPreheader', '');

        // Reset character counts for these fields
        setFieldCharCount(prev => ({
            ...prev,
            resendSubjectLine: 0,
            resendPreheader: 0
        }));

        // Hide the resend fields section
        setShowFields(false);
    };
    const handleImageUpload = (): void => {
        setShowImageModal(true)
    }

    const handleCloseImageModal = (): void => {
        setShowImageModal(false)
    }
    useEffect(() => {
        if (!editorContent) {
            setLinks([]);
            setImages([]);
            setEditorDecodedContent('');
            return;
        }

        // Decode HTML entities before parsing
        const decodedContent = he.decode(editorContent);
        const extractLinksAndImages = (htmlContent: string): { links: string[]; images: { src: string; alt: string }[] } => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, "text/html");

            // Extract links
            const links = Array.from(doc.querySelectorAll("a"))
                .map((a) => a.getAttribute("href") ?? "")
                .filter((href) => href.startsWith('http'));
            const uniqueLinks = Array.from(new Set(links));

            // Extract images with alt text
            const images = Array.from(doc.querySelectorAll("img"))
                .map((img) => ({
                    src: img.getAttribute("src") ?? "",
                    alt: img.getAttribute("alt") ?? ""
                }))
                .filter((img) => img.src);
            return { links: uniqueLinks, images };
        };

        // Extract links and images after decoding
        const { links, images } = extractLinksAndImages(decodedContent);
        setLinks(links);
        setImages(images);
        setEditorDecodedContent(decodedContent);
    }, [editorContent]);


    const onValid = (data: any): void => {
        setTestEmailModalOpen(true);
    };

    const onInvalid = (errors: any): void => {
        console.log("Form has errors:", errors);
    };

    const handleSendTestEmail = (): void => {
        void handleSubmit(onValid, onInvalid)();
    };

    const formData = {
        clientId: user?.clientId ?? 0,
        templateName: watch("templateName"),
        templateContent: editorContent,
        subjectLine: watch("subjectLine"),
        fromName: watch("fromName"),
        fromEmail: `${watch("fromEmail")}@${domainValue}`,
        preheader: watch("preheader"),
        replyToEmail: watch("replyToEmail"),

    };

    const handleVersionList = async (): Promise<void> => {
        console.log(3232323);
        setShowVersionPanel(true);
        setVersionPanelLoading(true);
        try {

            const res = await gettemplateVersionList(templateData.templateIdentifier);
            if (res.status === 200) {
                if (res.data.result === 1) {
                    console.log(res.data.data);
                    setTemplateVersionData(res.data.data);
                    setVersionPanelLoading(false);
                } else if (res.data.messages === 'Template was not added.') {
                    setVersionPanelLoading(false);
                    NotificationManager.error('Template name already exists');
                }
                else if (res.data.messages === 'Invalid From Email address format') {
                    setVersionPanelLoading(false);
                    NotificationManager.error('Please enter a valid email address');
                }
                else {
                    setVersionPanelLoading(false);
                    NotificationManager.error(UNKNOWN_ERR);
                }
            }
        } catch (error) {
            console.error('Error occurred:', error);
            setVersionPanelLoading(false);
            NotificationManager.error(UNKNOWN_ERR);
        } finally {
            setVersionPanelLoading(false);
        }
    }
    const handleCloseVersionList = (): void => {
        setShowVersionPanel(false);
    }
    const handleUpdateVersion = async (versionId: number): Promise<void> => {
        setVersionPanelLoading(true);
        try {

            const res = await updateTemplateVersion(templateData.templateIdentifier, versionId, user?.id ?? 0);
            if (res.status === 200) {
                getemplateData()
                if (res.data.result === 1) {
                    console.log(res.data.data);
                    setVersionPanelLoading(false);
                    NotificationManager.success(UPDATE_TEMPLATE_VERSION_SUCCESS_MESSAGE);
                }
                else {
                    setVersionPanelLoading(false);
                    NotificationManager.error(UNKNOWN_ERR);
                }
            }
        } catch (error) {
            console.error('Error occurred:', error);
            setVersionPanelLoading(false);
            NotificationManager.error(UNKNOWN_ERR);
        } finally {
            setVersionPanelLoading(false);
        }
    }

    const handleUpdateTemplateConfirm = async (): Promise<void> => {
        if (pendingTemplateData) {
            setIsModalSaveLoading(true);
            try {
                await processTemplateUpdate(pendingTemplateData); // Use the same function
                setShowUpdateTemplateModal(false);
            } catch (error) {
                console.error("Error in confirmation update:", error);
            } finally {
                setIsModalSaveLoading(false);
            }
        }
    };

    const handleUpdateTemplateClose = (): void => {
        setShowUpdateTemplateModal(false);
    }

    return (
        <div className="flex flex-row justify-start">
            <MainLayout>

                <div className="flex justify-between items-center">


                    <div className="w-full relative">
                        {isDataLoading ? (
                            <div className="flex justify-center items-center min-h-screen">
                                <Loader />
                            </div>

                        ) :
                            <div>
                                <h1 className="text-2xl text-title font-semibold flex items-center gap-2">
                                    Template ID: {id}
                                    <div className="flex items-center gap-[2px]">
                                            <span
                                                className="px-2.5 py-0.5 rounded-full bg-white border-gray-300 text-14 shadow-sm cursor-pointer"
                                                onClick={() => void handleVersionList()}
                                            >
                                                V{templateData?.templateVersion}
                                            </span>
                                            <div className="icon-hover-container">
                                        <BootstrapTooltip title="View version history" style={{marginLeft:"-6px"}}>
                                            <span>
                                                <HugeiconsIcon
                                                icon={Clock01Icon}
                                                size={20}
                                                color="#3A3A3A"
                                                strokeWidth={0.2}
                                                onClick={() => void handleVersionList()}
                                                />
                                            </span>
                                        </BootstrapTooltip>
                                    </div>
                                      
                                        {/* <BootstrapTooltip title="View version history">
    <IconButton
      onClick={() => void handleVersionList()}
      size="small"
      sx={{
        p: 0.2, // reduce padding so icon is closer
        ml: "-2px", // small negative margin to pull icon left
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.05)",
        },
      }}
    >
      <HugeiconsIcon
        icon={CircleArrowMoveUpLeftIcon}
        size={24}
        strokeWidth={0.2}
        color="#3a3a3a"
      />
    </IconButton>
  </BootstrapTooltip> */}
                                    </div>

                                </h1>

                                <Box sx={{ flexGrow: 1 }}>

                                    {templateSummary ? (
                                        <div className='campaign-form-container' style={{ width: '75%' }}>
                                            <TemplateSummary template={templateSummaryData} label={"Template updated successfully"} mode={"edit"} />
                                        </div>
                                    ) : (
                                        <div className='campaign-form-container' style={{ width: '100%' }}>
                                            <form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            void handleSubmit(onSubmit)(e);
                                                        }}
                                                    >
                                            <Grid container spacing={0}>


                                                <Grid item xs={4.8} sx={{ paddingRight: '20px' }}>
                                                    
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="templateName"
                                                                        control={control}
                                                                        defaultValue=""
                                                                        render={({ field }) => (
                                                                            <TextField
                                                                                {...field}
                                                                                fullWidth
                                                                                autoComplete="off"
                                                                                label='Template Name*'
                                                                                placeholder={TEMPLATE_NAME}
                                                                                error={Boolean(errors.templateName)}
                                                                            />
                                                                        )}
                                                                    />
                                                                    {errors.templateName && (
                                                                        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                            <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                            {errors.templateName?.message} {/* Show the error message */}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <div className="mb-[10px]">
                                                                <Controller
                                                                    name="fromName"
                                                                    control={control}
                                                                    defaultValue=""
                                                                    render={({ field }) =>
                                                                    (
                                                                        <>
                                                                            <TextField
                                                                                {...field}
                                                                                fullWidth
                                                                                autoComplete="off"
                                                                                label="From Name*"
                                                                                placeholder={TEMPLATE_FROM_NAME}
                                                                                error={Boolean(errors.fromName)}
                                                                                inputProps={{
                                                                                    maxLength: 100,
                                                                                }}
                                                                                onChange={(event) => {
                                                                                    field.onChange(event); // Pass the change to react-hook-form
                                                                                    handleInputChange(event); // Update the character count
                                                                                }}
                                                                            />
                                                                            {errors.fromName && (
                                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                    {errors.fromName?.message} {/* Show the error message */}
                                                                                </div>
                                                                            )}
                                                                            <Typography variant="caption" color={fieldCharCount.fromName === 100 ? 'error' : 'textSecondary'} style={{ marginTop: '4px', display: 'block', textAlign: 'right' }}>
                                                                                {`${100 - fieldCharCount.fromName} characters left`}
                                                                            </Typography>
                                                                        </>
                                                                    )}
                                                                />
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <div className="mb-[30px] flex flex-col">
                                                                <Controller
                                                                    name="fromEmail"
                                                                    control={control}
                                                                    defaultValue=""
                                                                    render={({ field }) => (
                                                                        <div className="flex items-center">
                                                                            {/* Input Field (No Border) */}
                                                                            <TextField
                                                                                {...field}
                                                                                autoComplete="off"
                                                                                label="From Email*"
                                                                                placeholder="Enter your email prefix"
                                                                                onChange={(e) => {
                                                                                    const prefix = e.target.value.split("@")[0]; // Keep only text before "@"
                                                                                    field.onChange(prefix); // Update field value
                                                                                }}
                                                                                sx={{ width: "250px" }} // Keep a fixed width
                                                                                error={Boolean(errors.fromEmail)}
                                                                            />
                                                                            {/* Static Domain Display */}
                                                                            <span className="ml-1" style={{ color: '#3A3A3A' }}>@{domainValue}</span>
                                                                        </div>
                                                                    )}
                                                                />
                                                                {/* Validation Error Message */}
                                                                {errors.fromEmail && (
                                                                    <div className="flex items-center text-primary mt-1 text-md font-normal">
                                                                        <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1" />
                                                                        <span>{errors.fromEmail?.message}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                                <div className="mb-[30px]">
                                                                    <Controller
                                                                        name="replyToEmail"
                                                                        control={control}
                                                                        defaultValue=""
                                                                        render={({ field }) => 
                                                                        (
                                                                            <>
                                                                                <TextField
                                                                                    {...field}
                                                                                    fullWidth
                                                                                    autoComplete="off"
                                                                                    label="Reply-To Email"
                                                                                    placeholder={TEMPLATE_REPLY_TO_EMAIL}
                                                                                    error={Boolean(errors.replyToEmail)}
                                                                                    inputProps={{
                                                                                        maxLength: 100,
                                                                                    }}
                                                                                />
                                                                                {errors.replyToEmail && (
                                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                                    {errors.replyToEmail?.message} {/* Show the error message */}
                                                                                </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    />
                                                            </div>
                                                            </Grid>
                                                        <Grid item xs={12}>
                                                            <div className="mb-[30px]">
                                                                <Controller
                                                                    name="unsubscribeLink"
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <Autocomplete
                                                                            options={links}
                                                                            getOptionLabel={(option) => option}
                                                                            popupIcon={
                                                                                <HugeiconsIcon
                                                                                    icon={ArrowDown01Icon}
                                                                                    size={18}
                                                                                    color="#3A3A3A"
                                                                                    strokeWidth={0.2}

                                                                                />
                                                                            }
                                                                            //@ts-ignore
                                                                            value={links.includes(watch("unsubscribeLink")) ? watch("unsubscribeLink") : null} // Ensure valid selection
                                                                            //@ts-ignore
                                                                            onChange={(_, selectedLink) => setValue("unsubscribeLink", selectedLink)}

                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    label="Select Unsubscribe Link"
                                                                                    placeholder="Select a link"
                                                                                    error={Boolean(errors.unsubscribeLink)}
                                                                                    helperText={errors.unsubscribeLink?.message}
                                                                                />
                                                                            )}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                        </Grid>



                                                        <Grid item xs={12}>
                                                            <div className="mb-[10px]">
                                                                <Controller
                                                                    name="subjectLine"
                                                                    control={control}
                                                                    defaultValue=""
                                                                    render={({ field }) =>
                                                                    (
                                                                        <>
                                                                            <TextField
                                                                                {...field}
                                                                                fullWidth
                                                                                autoComplete="off"
                                                                                label="Subject Line*"
                                                                                placeholder={TEMPLATE__SUBJECT_LINE}
                                                                                error={Boolean(errors.subjectLine)}
                                                                                inputProps={{
                                                                                    maxLength: 200,
                                                                                }}
                                                                                onChange={async (event) => {
                                                                                    field.onChange(event); // Pass the change to react-hook-form
                                                                                    handleInputChange(event); // Update the character count
                                                                                    await checkSpelling(event.target.value) ? setSubjectLineSpellingError('') : setSubjectLineSpellingError('There are spelling mistakes');
                                                                                }}
                                                                            />
                                                                            {errors.subjectLine && (
                                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                    {errors.subjectLine?.message} {/* Show the error message */}
                                                                                </div>
                                                                            )}
                                                                            
                                                                            <Typography variant="caption" color={fieldCharCount.subjectLine === 200 ? 'error' : 'textSecondary'} style={{ marginTop: '4px', display: 'block', textAlign: 'right' }}>
                                                                                {`${200 - fieldCharCount.subjectLine} characters left`}
                                                                            </Typography>
                                                                        </>
                                                                    )}
                                                                />
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <div >
                                                                <Controller
                                                                    name="preheader"
                                                                    control={control}
                                                                    defaultValue=""
                                                                    render={({ field }) =>
                                                                    (
                                                                        <>
                                                                            <TextField
                                                                                {...field}
                                                                                fullWidth
                                                                                autoComplete="off"
                                                                                label="Preheader*"
                                                                                placeholder={TEMPLATE_PREHEADER}
                                                                                error={Boolean(errors.preheader)}
                                                                                inputProps={{
                                                                                    maxLength: 500,
                                                                                }}
                                                                                onChange={async (event) => {
                                                                                    field.onChange(event); // Pass the change to react-hook-form
                                                                                    handleInputChange(event); // Update the character count
                                                                                    await checkSpelling(event.target.value) ? setPreheaderSpellingError('') : setPreheaderSpellingError('There are spelling mistakes');
                                                                                }}
                                                                            />
                                                                            {errors.preheader && (
                                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                                                    {errors.preheader?.message} {/* Show the error message */}
                                                                                </div>
                                                                            )}
                                                                            
                                                                            <Typography variant="caption" color={fieldCharCount.preheader === 500 ? 'error' : 'textSecondary'} style={{ marginTop: '4px', display: 'block', textAlign: 'right' }}>
                                                                                {`${500 - fieldCharCount.preheader} characters left`}
                                                                            </Typography>
                                                                        </>
                                                                    )}
                                                                />
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            {!showFields ? (
                                                                <div
                                                                    className="flex items-center justify-center mb-[10px] cursor-pointer"
                                                                    style={{ textAlign: 'center' }}
                                                                    onClick={() => {
                                                                        setResendFields([{ subjectLine: '', preheader: '' }]);
                                                                        setShowFields(true)
                                                                    }}
                                                                >
                                                                    <HugeiconsIcon
                                                                        icon={AddCircleStrokeRounded}
                                                                        size={18}
                                                                        color="#3a3a3a"
                                                                        strokeWidth={0.2}
                                                                    />

                                                                    <Button
                                                                        disableRipple
                                                                        sx={{
                                                                            color: "#3a3a3a",
                                                                            textTransform: 'none',
                                                                            fontWeight: 500,
                                                                            '&:hover': {
                                                                                backgroundColor: 'transparent',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <span className="flex items-center font-medium text-[#3a3a3a]">
                                                                            <span style={{ textDecoration: 'underline' }}>
                                                                                Add resend subject line & preheader
                                                                            </span>
                                                                        </span>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                fontStyle: 'italic',
                                                                                color: '#3a3a3a'
                                                                            }}
                                                                        >
                                                                            (optional)
                                                                        </Typography>
                                                                    </Button>

                                                                    <BootstrapTooltip title={TEMPLATE_PREHEADER_RESEND_MESSAGE}>
                                                                        <span>
                                                                            <HugeiconsIcon
                                                                                icon={HelpCircleIcon}
                                                                                size={18}
                                                                                color="#3a3a3a"
                                                                                strokeWidth={0.2}
                                                                            />
                                                                        </span>
                                                                    </BootstrapTooltip>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {
                                                                        resendFields.length === 1 && (

                                                                            <div
                                                                                className="flex items-center justify-center mb-[10px] cursor-pointer"
                                                                                style={{ textAlign: 'center' }}
                                                                            >
                                                                                <HugeiconsIcon
                                                                                    icon={Delete03Icon}
                                                                                    size={18}
                                                                                    color="red"
                                                                                    strokeWidth={.2}
                                                                                />
                                                                                <Button
                                                                                    disableRipple
                                                                                    sx={{
                                                                                        color: 'red',
                                                                                        textTransform: 'none',
                                                                                        fontWeight: 400,
                                                                                        '&:hover': {
                                                                                            backgroundColor: 'transparent',
                                                                                        },
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        setShowFields(false);
                                                                                        // setResendFields([{ subjectLine: '', preheader: '' }]);
                                                                                        handleRemoveResendField(0)
                                                                                    }}
                                                                                >
                                                                                    Delete resend subject line & preheader
                                                                                </Button>

                                                                                <BootstrapTooltip title={TEMPLATE_RESEND_SUBJECT_LINE_MESSAGE}>

                                                                                    <HugeiconsIcon
                                                                                        icon={HelpCircleIcon}
                                                                                        size={18}
                                                                                        color="#3a3a3a"
                                                                                        strokeWidth={0.2}
                                                                                    />
                                                                                </BootstrapTooltip>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </>
                                                            )}
                                                        </Grid>
                                                        {showFields && (
                                                            <>
                                                                {resendFields.map((resend, idx) => (
                                                                    <React.Fragment key={idx}>
                                                                        <Grid item xs={12}>
                                                                            <div className="mb-[10px] mt-[10px] flex items-center">
                                                                                <div style={{ width: '48%' }}>
                                                                                    <TextField
                                                                                        fullWidth
                                                                                        autoComplete="off"
                                                                                        label={`Resend Subject Line ${idx + 1}`}
                                                                                        placeholder="Resend Subject Line"
                                                                                        value={resend.subjectLine}
                                                                                        inputProps={{ maxLength: 200 }}
                                                                                        onChange={e => handleResendFieldChange(idx, 'subjectLine', e.target.value)}
                                                                                        sx={{ marginRight: 2 }}
                                                                                    />
                                                                                    <Typography
                                                                                        variant="caption"
                                                                                        color={resend.subjectLine.length === 200 ? 'error' : 'textSecondary'}
                                                                                        style={{ marginTop: '4px', display: 'block', textAlign: 'right' }}
                                                                                    >
                                                                                        {`${200 - resend.subjectLine.length} characters left`}
                                                                                    </Typography>
                                                                                </div>
                                                                                <div style={{ width: '48%', marginLeft: '2%' }}>
                                                                                    <TextField
                                                                                        fullWidth
                                                                                        autoComplete="off"
                                                                                        label={`Resend Preheader ${idx + 1}`}
                                                                                        placeholder="Resend Preheader"
                                                                                        value={resend.preheader}
                                                                                        inputProps={{ maxLength: 500 }}
                                                                                        onChange={e => handleResendFieldChange(idx, 'preheader', e.target.value)}
                                                                                        sx={{ marginRight: 2 }}
                                                                                    />
                                                                                    <Typography
                                                                                        variant="caption"
                                                                                        color={resend.preheader.length === 500 ? 'error' : 'textSecondary'}
                                                                                        style={{ marginTop: '4px', display: 'block', textAlign: 'right' }}
                                                                                    >
                                                                                        {`${500 - resend.preheader.length} characters left`}
                                                                                    </Typography>
                                                                                </div>
                                                                                {resendFields.length > 1 && (
                                                                                    <IconButton onClick={() => handleRemoveResendField(idx)} color="error" sx={{ top: '-12px' }}>
                                                                                        <HugeiconsIcon icon={Delete03Icon} size={18} />
                                                                                    </IconButton>
                                                                                )}
                                                                            </div>
                                                                        </Grid>
                                                                    </React.Fragment>
                                                                ))}
                                                                {resendFields.length < ResendMaxValue && (
                                                                    <div className="flex justify-center">
                                                                        <Button onClick={handleAddResendField} variant='outlined' sx={{ borderRadius: '50px', padding: '6px 16px', textTransform: 'none', mt: 1, mb: 2 }}>
                                                                            Add resend subject line & preheader
                                                                        </Button>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}

                                                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mt-6">
                                                            {/* Left-aligned checkbox with tooltip */}
                                                            <div className="flex items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id="newVersionCheckbox"
                                                                    checked={isNewVersion}
                                                                    onChange={(e) => {
                                                                        setIsNewVersion(e.target.checked);
                                                                        console.log('isNewVersion:', e.target.checked);
                                                                    }}
                                                                    className="mr-2"
                                                                />
                                                                <label htmlFor="newVersionCheckbox" className="text-[#3a3a3a] mr-1 font-medium">
                                                                    Save as New Version
                                                                </label>
                                                                <BootstrapTooltip title="Do you want to save it as a new version">
                                                                    <span className="cursor-pointer mr-2">
                                                                        <HugeiconsIcon
                                                                            icon={HelpCircleIcon}
                                                                            size={18}
                                                                            color="#3a3a3a"
                                                                            strokeWidth={0.2}
                                                                        />
                                                                    </span>
                                                                </BootstrapTooltip>
                                                            </div>

                                                            {/* Right-aligned buttons */}
                                                            <div className="flex gap-x-3.5">
                                                                {/* <OutlineButton color='gray' onClick={handleCancel} disabled={isLoading}>
                                                                    Cancel
                                                                </OutlineButton>
                                                                <BootstrapTooltip
                                                                    title={isDisabled ? TEMPLATE_EDITING_DISABLED_MESSAGE : ""}
                                                                >
                                                                    <span>
                                                                        <GradientButton
                                                                            type="submit"
                                                                            color="red"
                                                                            onClick={handleCancel}
                                                                            disabled={ isLoading || isDisabled }
                                                                        >
                                                                            {!isLoading ? 'Update Template' : <span className="loading loading-spinner loading-xs text-white"></span>}
                                                                        </GradientButton>
                                                                    </span>
                                                                </BootstrapTooltip> */}
                                                            </div>
                                                        </div>

                                                </Grid>

                                                <Grid item xs={7.2} sx={{ paddingLeft: '20px' }}>
                                                    {/* <div className='flex justify-between mb-[20px]'>
                                                <div className='text-14 font-[700] text-muted'>Template Preview</div>
                                                <div className='text-14 font-[600] text-red cursor-pointer' onClick={() => setTestEmailModalOpen(true)}>Send Test Email</div>
                                            </div> */}
                                                    {/* 
                                            <div className="relative">
                                                <img src={'/assets/images/TemplatePreview1.png'} alt="" className="icon-hover" />
                                                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity">
                                               <HugeiconsIcon
                                                    icon={ViewStrokeRounded}
                                                    size={24}
                                                    color="currentcolor"
                                                    strokeWidth={0.5}
                                                    className={`cursor-pointer text-white ${!templateData?.templateContent ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                    onClick={templateData?.templateContent ? () => setIsPreviewModalOpen(true) : undefined}
                                                />
                                                </div>
                                            </div> */}
                                                    <CustomEditor onHtmlChange={setEditorContent} initialHtml={editorContent} onImageUpload={handleImageUpload} editorRef={editorRef} isEditPage={true}
                                                        onSendTestEmail={() => void handleSendTestEmail()} />
                                                </Grid>
                                            </Grid>
                                            <Divider
                                                sx={{ color: '#D9D9D9', marginBottom: '30px', marginTop: '20px' }}
                                                />
                                                <div className="flex justify-between items-center gap-x-3.5">
                                                <OutlineButton color='gray' onClick={handleCancel} disabled={isLoading}>
                                                                    Cancel
                                                                </OutlineButton>
                                                                <BootstrapTooltip
                                                                    title={isDisabled ? TEMPLATE_EDITING_DISABLED_MESSAGE : ""}
                                                                >
                                                                    <span>
                                                                        <GradientButton
                                                                            type="submit"
                                                                            color="red"
                                                                            onClick={handleCancel}
                                                                            disabled={ isLoading || isDisabled }
                                                                        >
                                                                            {!isLoading ? 'Update Template' : <span className="loading loading-spinner loading-xs text-white"></span>}
                                                                        </GradientButton>
                                                                    </span>
                                                                </BootstrapTooltip>
                                                </div>
                                            </form>
                                            {/* <TemplatePreview 
                                        isOpen={isPreviewModalOpen} 
                                        onClose={() => setIsPreviewModalOpen(false)} 
                                        content={templateData?.templateContent || ''} 
                                    /> */}
                                        </div>
                                    )}

                                </Box>
                            </div>
                        }
                        <MUIModal openModal={showImageModal} closeModal={handleCloseImageModal} title='Upload Images' width='50%'>
                            <TemplateImageUpload closeModal={handleCloseImageModal} imageData={images} onFilesUpload={(files) => setUploadedFiles(files)} updateEditorContent={updateEditorContent} templateIdentifier={templateData?.templateIdentifier} templateActiveVersionData={templateData?.templateVersion} TemplateName={templateName} editorContent={editorContent} />
                        </MUIModal>
                        <MUIModal openModal={showVersionPanel} closeModal={handleCloseVersionList} title='Version History' width='30%'>
                            <TemplateVersionHistory templateVersionData={templateVersionData} isDisabled = {isDisabled} templateData={templateData} templateName={templateName} VersionPanelLoading={VersionPanelLoading} handleUpdateVersion={(versionId) => {
                                void handleUpdateVersion(versionId);
                            }} />
                        </MUIModal>
                    </div>

                </div>
                <BootstrapDialog onClose={handleUpdateTemplateClose} aria-labelledby="customized-dialog-title" open={showUpdateTemplateModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        Active Template Confirmation
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={handleUpdateTemplateClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>{'This template may be used in some active campaigns. Proceeding may impact the existing workflow. Do you want to continue?'}</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleUpdateTemplateClose} width='100px'>No</OutlineButton>
                        <GradientButton type='button' color='red' onClick={() => { void handleUpdateTemplateConfirm(); }} width='100px'>{!isModalSaveLoading ? 'Yes' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                    </DialogActions>
                </BootstrapDialog>

            </MainLayout>
            <SendTestEmail open={testEmailModalOpen} onClose={() => setTestEmailModalOpen(false)} TemplateData={formData} />
        </div>
    )
}

export default EditTemplateForm